import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUyFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_52728)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1368 8.62109H0.861131C0.385058 8.62109 -0.000976562 9.00703 -0.000976562 9.4831V40.5175C-0.000976562 40.9936 0.385058 41.3796 0.861131 41.3796H49.1369C49.613 41.3796 49.999 40.9936 49.999 40.5175V9.4831C49.9989 9.00703 49.6129 8.62109 49.1368 8.62109Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.999 12.2607H18.1025V15.9004H49.999V12.2607Z",
					fill: "#4173CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9989 15.9004H-0.000976562V19.54H49.9989V15.9004Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.999 19.54H18.1025V23.1797H49.999V19.54Z",
					fill: "#4173CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9989 23.1797H-0.000976562V26.8193H49.9989V23.1797Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9989 26.8203H-0.000976562V30.46H49.9989V26.8203Z",
					fill: "#4173CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9989 30.46H-0.000976562V34.0996H49.9989V30.46Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9989 34.0996H-0.000976562V37.7393H49.9989V34.0996Z",
					fill: "#4173CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.24707 10.9023L7.68916 17.5755L9.9457 16.6407L6.24707 10.9023Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.24707 10.9023L8.81738 17.1081L7.68916 17.5755L6.24707 10.9023Z",
					fill: "#FFCD5A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.855 24.4427L10.4128 17.7695L8.15625 18.7043L11.855 24.4427Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.8551 24.4427L9.28467 18.2369L10.4129 17.7695L11.8551 24.4427Z",
					fill: "#FFCD5A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.8205 14.8682L9.14746 16.3103L10.0821 18.5668L15.8205 14.8682Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.8205 14.8682L9.61475 17.4385L9.14746 16.3103L15.8205 14.8682Z",
					fill: "#FFCD5A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M2.28125 20.476L8.95429 19.0339L8.01952 16.7773L2.28125 20.476Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M2.28125 20.4766L8.4869 17.9062L8.95429 19.0345L2.28125 20.4766Z",
					fill: "#FFCD5A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.855 10.9023L8.15625 16.6407L10.4128 17.5755L11.855 10.9023Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.855 10.9023L9.28457 17.1081L8.15625 16.6407L11.855 10.9023Z",
					fill: "#FFCD5A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.24707 24.4427L9.9457 18.7043L7.68916 17.7695L6.24707 24.4427Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.24707 24.4421L8.81738 18.2363L9.9457 18.7037L6.24707 24.4421Z",
					fill: "#FFCD5A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.8205 20.476L10.0821 16.7773L9.14746 19.0339L15.8205 20.476Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.821 20.476L9.61523 17.9057L10.0826 16.7773L15.821 20.476Z",
					fill: "#FFCD5A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M2.28125 14.8682L8.01952 18.5668L8.95429 16.3103L2.28125 14.8682Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M2.28125 14.8682L8.4869 17.4385L8.01952 18.5668L2.28125 14.8682Z",
					fill: "#FFCD5A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.05088 10.3447L7.82959 17.0616H10.2721L9.05088 10.3447Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.05088 10.3447V17.0616H7.82959L9.05088 10.3447Z",
					fill: "#FFCD5A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.05088 25.0001L10.2721 18.2832H7.82959L9.05088 25.0001Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.05078 25.0001V18.2832H10.272L9.05078 25.0001Z",
					fill: "#FFCD5A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.3785 17.6725L9.66162 16.4512V18.8936L16.3785 17.6725Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.3785 17.6725H9.66162V16.4512L16.3785 17.6725Z",
					fill: "#FFCD5A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1.72314 17.6725L8.44003 18.8936V16.4512L1.72314 17.6725Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1.72314 17.6729H8.44003V18.894L1.72314 17.6729Z",
					fill: "#FFCD5A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.2323 12.4912L8.61914 16.3772L10.3463 18.1044L14.2323 12.4912Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.2323 12.4912L9.48271 17.2408L8.61914 16.3772L14.2323 12.4912Z",
					fill: "#FFCD5A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M3.86963 22.8534L9.4827 18.9674L7.75556 17.2402L3.86963 22.8534Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M3.86963 22.8541L8.61913 18.1045L9.4827 18.9681L3.86963 22.8541Z",
					fill: "#FFCD5A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.2323 22.8534L10.3463 17.2402L8.61914 18.9674L14.2323 22.8534Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.232 22.8534L9.48242 18.1038L10.346 17.2402L14.232 22.8534Z",
					fill: "#FFCD5A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M3.86963 12.4912L7.75556 18.1044L9.4827 16.3772L3.86963 12.4912Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M3.86963 12.4912L8.61913 17.2408L7.75556 18.1044L3.86963 12.4912Z",
					fill: "#FFCD5A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.05078 20.1152C10.3997 20.1152 11.4932 19.0217 11.4932 17.6728C11.4932 16.324 10.3997 15.2305 9.05078 15.2305C7.70189 15.2305 6.6084 16.324 6.6084 17.6728C6.6084 19.0217 7.70189 20.1152 9.05078 20.1152Z",
					fill: "#FFE15A"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_52728",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgUyFlag);
export { ForwardRef as ReactComponent };
